import SurveysProfilerError from './SurveysProfilerError';
class SurveyNotFound extends SurveysProfilerError {
    constructor(options) {
        super('The survey profiler was not found', options);
    }
}
export default SurveyNotFound;
